import { render, staticRenderFns } from "./productPurchased.vue?vue&type=template&id=452a0ee2&scoped=true"
import script from "./productPurchased.vue?vue&type=script&lang=js"
export * from "./productPurchased.vue?vue&type=script&lang=js"
import style0 from "./productPurchased.vue?vue&type=style&index=0&id=452a0ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452a0ee2",
  null
  
)

export default component.exports